/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./VehicleLoanReport.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useDispatch, useSelector } from "react-redux";
import { FaRupeeSign } from "react-icons/fa";

const VehicleLoanReport = () => {
  const [loans, setLoans] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [groups, setGroups] = useState([]);
  const [centers, setCenters] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  const [filters, setFilters] = useState({
    schemeName: "",
    status: "",
    loanAppliedDate: "",
  });

  const { profile } = useSelector((state) => state.userProfile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  const fetchLoanReport = async (page = currentPage) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://payyug.in/api//gold-loan/list`,   // ✅ API NOT CHANGED
        {
          params: {
            superAdminId: profile.superAdminId || 14,
            branchId: profile.id,
            page,
            limit: 10,
          },
        }
      );

      setLoans(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (error) {
      console.error("Error fetching vehicle loan report:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchGroups = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api//groupupdate/getall?LoanofficerId=${profile.id}&CenterId=${selectedCenter?.id}&limit=10000`
      );
      setGroups(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  const fetchCenters = async () => {
    try {
      const res = await axios.get(
        `https://payyug.in/api/group/centre?LoanofficerId=${profile.id}&limit=10000`
      );
      setCenters(res.data?.data || []);
    } catch (err) {
      console.error("Fetch Error:", err);
    }
  };

  useEffect(() => {
    fetchLoanReport(currentPage);
  }, [currentPage, profile]);

  useEffect(() => {
    fetchLoanReport(currentPage);
  }, []);

  const handleFilter = () => {
    setCurrentPage(1);
    fetchLoanReport(1);
  };

  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleViewEmi = (loan) =>
    navigate(
      // `/vehicleloan/vehicleLoanReport/vehicleLoanEmiDetails/${loan.id}`,
      `/vehicleloan/vehicleLoanEmiDetails/${loan.id}`,
      { state: { loan } }
    );

  const handleViewLoanCard = (loan) =>
    navigate(
      `/vehicleloan/vehicleloanreport/VehicleLoanEmiCard/${loan.id}`,
      { state: { loan } }
    );

  const filteredLoans = loans.filter((loan) => {
    const schemeMatch =
      !filters.schemeName ||
      loan.schemeName
        ?.toLowerCase()
        .includes(filters.schemeName.toLowerCase());

    const statusMatch =
      !filters.status ||
      loan.status?.toLowerCase() === filters.status.toLowerCase();

    const dateMatch =
      !filters.loanAppliedDate ||
      new Date(loan.loanAppliedDate).toLocaleDateString("en-CA") ===
        filters.loanAppliedDate;

    return schemeMatch && statusMatch && dateMatch;
  });

  if (loading) {
    return (
      <div className="vehicle-loan-report-loadingWrapper">
        <div className="vehicle-loan-report-spinner"></div>
        <p>Loading Vehicle Loan Report...</p>
      </div>
    );
  }

  return (
    <div className="vehicle-loan-report-app">
      <h2 className="vehicle-loan-report-title">
        Vehicle Loan Report
      </h2>

      <div className="vehicle-loan-report-filterCard">
        <input
          type="text"
          className="filterInput"
          placeholder="🔎 Filter by Scheme"
          value={filters.schemeName}
          onChange={(e) => handleFilterChange("schemeName", e.target.value)}
        />
        <select
          className="filterSelect"
          value={filters.status}
          onChange={(e) => handleFilterChange("status", e.target.value)}
        >
          <option value="">All Status</option>
          <option value="ACTIVE">ACTIVE</option>
          <option value="pending">pending</option>
          <option value="rejected">Rejected</option>
        </select>
        <input
          type="date"
          className="filterInput"
          value={filters.loanAppliedDate}
          onChange={(e) =>
            handleFilterChange("loanAppliedDate", e.target.value)
          }
        />
      </div>

      <div className="vehicle-loan-report-tableWrapper">
        <table className="vehicle-loan-report-table">
          <thead>
            <tr>
              <th>Account No</th>
              <th>Loan Amount</th>
              <th>Customer Name</th>
              <th>Status</th>
              <th>View EMI</th>
              <th>Loan Card</th>
            </tr>
          </thead>
          <tbody>
            {filteredLoans.length > 0 ? (
              filteredLoans.map((item) => (
                <tr key={item.id}>
                  <td>{item.loanAccountNumber}</td>
                  <td>{item.loanAmount}</td>
                  <td>{item.userName}</td>
                  <td>{item.status}</td>
                  <td>
                    {item.status.toLowerCase() === "active" ? (
                      <button
                        className="vehicle-loan-report-btn-view"
                        onClick={() => handleViewEmi(item)}
                      >
                        <FaRupeeSign />
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>
                    {item.status.toLowerCase() === "active" ? (
                      <button
                        className="vehicle-loan-report-btn-card"
                        onClick={() => handleViewLoanCard(item)}
                      >
                        Loan Card
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="vehicle-loan-report-pagination">
        <button
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          ⬅ Prev
        </button>

        <span>
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default VehicleLoanReport;